import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/antd/es/progress/index.js
// module id = 287
// module chunks = 0